<atlas-modal #modal titleText="{{ headerText$ | async }}">
    <atlas-modal-header>{{ headerText$ | async }}</atlas-modal-header>
    <atlas-modal-content width="550px" maxHeight="400px">
        <div *ngIf="descriptionText$ | async as description">{{ description }}</div>
        <div class="business-navbar__change-subscription__input">
            <atlas-textarea [(text)]="name" height="20px" limit="40"
                            [prescriptionText]="nameLabel$ | async"></atlas-textarea>
        </div>
        <div class="business-navbar__change-subscription__input">
            <atlas-textarea [(text)]="phoneNumber" height="20px" limit="40"
                            [prescriptionText]="phoneNumberLabel$ | async"></atlas-textarea>
        </div>
        <div class="business-navbar__change-subscription__message-composer">
            <atlas-textarea [(text)]="messageTxt" maxHeight="280px" limit="500"
                            [prescriptionText]="prescriptionText$ | async"></atlas-textarea>
        </div>
    </atlas-modal-content>
    <atlas-modal-footer>
        <atlas-button [text]="cancelText$ | async" (onClick)="closeModal()"></atlas-button>
        <atlas-button [text]="submitText$ | async" [raised]="true" [loading]="sendingMessage" (onClick)="sendMessage()" [disabled]="messageTxt?.length > 500 || messageTxt?.length === 0"></atlas-button>
    </atlas-modal-footer>
</atlas-modal>
